<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <path class="fil0" d="M3563.05 2151.9l-0.07 1411.12 -1411.06 0 529.2 -529.19 -684.16 -684.12 352.75 -352.75 684.14 684.14 529.2 -529.2zm-3174.98 -2116.59l1213.29 1213.3 -352.77 352.77 -1213.32 -1213.27 352.8 -352.8zm1763.85 -0.01l1411.13 0.06 0 1411.06 -529.2 -529.2 -2645.78 2645.79 -352.8 -352.8 2645.85 -2645.72 -529.2 -529.19z"/>
 </g>
</svg>
